import { render, staticRenderFns } from "./activityResultsTable.vue?vue&type=template&id=68d3dd16"
import script from "./activityResultsTable.vue?vue&type=script&lang=js"
export * from "./activityResultsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports